/**
 * Cross-tab auth sync: when one tab logs out, all other tabs clear session and reload to login.
 * Uses localStorage `storage` events only (they fire in *other* tabs, not the tab that set the key).
 */

const LOGOUT_STORAGE_KEY = 'cstore_logout_broadcast'

/** Notify every other open tab that the user logged out. */
export function broadcastLogout(): void {
  if (globalThis.window === undefined) return

  try {
    localStorage.setItem(LOGOUT_STORAGE_KEY, String(Date.now()))
  } catch {
    // private mode / quota
  }
}

/**
 * Subscribe to logout from other tabs.
 * Returns an unsubscribe function.
 */
export function subscribeLogoutBroadcast(onLogout: () => void): () => void {
  if (globalThis.window === undefined) return () => {}

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== LOGOUT_STORAGE_KEY || event.newValue == null) return
    onLogout()
  }

  globalThis.addEventListener('storage', handleStorage)

  return () => {
    globalThis.removeEventListener('storage', handleStorage)
  }
}

/** Hard-navigate this tab to login (clears in-memory UI state). */
export function redirectAllTabsToLogin(): void {
  if (globalThis.window === undefined) return
  const pathname = globalThis.location.pathname
  if (pathname.includes('/login')) return
  const locale = pathname.startsWith('/ar') ? 'ar' : 'en'
  globalThis.location.href = `/${locale}/login`
}
